var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import EmptyListState from '../../components/EmptyListState';
import PageHeaderBlock from '../../components/PageHeaderBlock';
import DraftListItem from './partials/DraftListItem';
import ContentLoader from '../../components/ContentLoader';
import { localizeUrl } from '../../core/helpers/url-helper';
import { fetchDraftItems } from '../Cart/store/actions';
var mapStateToProps = function (state) { return ({
    collection: state.cart.draftItems.collection,
}); };
var mapDispatchToProps = {
    fetchDraftItems: fetchDraftItems,
};
var connector = connect(mapStateToProps, mapDispatchToProps);
var Drafts = /** @class */ (function (_super) {
    __extends(Drafts, _super);
    function Drafts() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Drafts.prototype.componentDidMount = function () {
        this.props.fetchDraftItems();
    };
    Drafts.prototype.render = function () {
        if ('loaded' !== this.props.collection.status || !Array.isArray(this.props.collection.items)) {
            return React.createElement(ContentLoader, null);
        }
        if (!this.props.collection.items.length) {
            return (React.createElement("div", { className: "h-padding-top--30" },
                React.createElement(EmptyListState, { image: "drafts-empty.svg", title: "drafts.empty.title", message: "drafts.empty.message", button: "drafts.empty.button.text", buttonLink: localizeUrl('/products') }),
                React.createElement("div", { className: "h-padding-y--30" })));
        }
        return (React.createElement("div", { className: "p-drafts" },
            React.createElement("div", { className: "p-drafts__header" },
                React.createElement(PageHeaderBlock, { title: "drafts.title", content: "drafts.subtitle" })),
            React.createElement("div", { className: "p-drafts__content" }, this.props.collection.items.map(function (item, key) { return React.createElement(DraftListItem, { key: key, item: item }); })),
            React.createElement("div", { className: "h-padding-y--30" })));
    };
    return Drafts;
}(React.Component));
export default connector(withRouter(Drafts));
